import React, {useEffect} from 'react';
import {BrowserRouter as Router, Route, Routes, Navigate, useNavigate} from 'react-router-dom';
import Login from './pages/Login';
import Register from './pages/Register';
import ResetPassword from './pages/ResetPassword';
import ForgotPassword from './pages/ForgotPassword';
import Dashboard from './pages/Dashboard';
import Home from './pages/Home';
import Team from './pages/Team';
import Products from './pages/Products';
import Profile from './pages/Profile';
import Instructions from './pages/Instructions';
import Audio from './pages/Audio';
import Video from './pages/Video';
import Statistics from './pages/Statistics';
import Scenarios from './pages/Scenarios';
import ConfirmEmail from './pages/ConfirmEmail';
import { isAuthenticated, logout } from './services/auth';
import { PermissionsProvider, usePermissions } from './components/PermissionsContext';
import { getUserPermissions } from './services/api';
import Presentations from "./pages/Presentations";

const ProtectedRoute: React.FC<{ children: React.ReactNode }> = ({children}) => {
  const navigate = useNavigate();
  const { setPermissions } = usePermissions();


  useEffect(() => {
    (async () => {
      if (isAuthenticated()) {
        try {
          const userId = localStorage.getItem('user_id');
          if (userId) {
            const permissions = await getUserPermissions(userId);
            setPermissions(permissions);
          }
        } catch (error) {
          console.error('Error fetching user permissions:', error);
        }
      } else {
        navigate('/login');
      }
    })();
  }, [setPermissions]);

  return isAuthenticated() ? <>{children}</> : null;
};

const App: React.FC = () => {
  return (
      <PermissionsProvider>
        <Router>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/confirm-email" element={<ConfirmEmail />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route path="/" element={
              <ProtectedRoute>
                <Dashboard />
              </ProtectedRoute>
            }>
              <Route index element={<Home />} />
              <Route path="/products" element={<Products />} />
              <Route path="/presentations" element={<Presentations />} />
              <Route path="/presentations/:id" element={<Presentations />} />
              <Route path="/scenarios" element={<Scenarios />} />
              <Route path="/scenarios/:id" element={<Scenarios />} />
              <Route path="/video" element={<Video />} />
              <Route path="/audio" element={<Audio />} />
              <Route path="/instructions" element={<Instructions />} />
              <Route path="/statistics" element={<Statistics />} />
              <Route path="/team" element={<Team />} />
              <Route path="/profile" element={<Profile />} />
              <Route path="/logout" element={<Logout />} />
            </Route>
            <Route path="*" element={<Navigate to={isAuthenticated() ? "/" : "/login"} />} />
          </Routes>
        </Router>
      </PermissionsProvider>
  );
};

const Logout: React.FC = () => {
  logout();
  return <Navigate to="/login" />;
};

export default App;
